// ========================================================================================================== SECTION 1
gsap.set('.co-wholesale-section-1-frame', { opacity: 0 });
gsap.to('.co-wholesale-section-1-frame', {
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
gsap.set('.co-wholesale-section-1-right-image-frame-2 img', { scale: 1 });
gsap.to('.co-wholesale-section-1-right-image-frame-2 img', {
  scrollTrigger: {
    trigger: "body",
    endTrigger: ".co-wholesale-section-1-frame",
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  scale: 1.05
});
// ========================================================================================================== SCROLLTOSCRIPT
function getSamePageAnchor (link) {
  if (
    link.protocol !== window.location.protocol ||
    link.host !== window.location.host ||
    link.pathname !== window.location.pathname ||
    link.search !== window.location.search
  ) {
    return false;
  }
  return link.hash;
}
function scrollToHash(hash, e) {
  const elem = hash ? document.querySelector(hash) : false;
  if(elem) {
    if(e) e.preventDefault();
    gsap.to(window, {scrollTo: elem, duration: 0.1});
  }
}
document.querySelectorAll('a[href]').forEach(a => {
  a.addEventListener('click', e => {
    scrollToHash(getSamePageAnchor(a), e);
  });
});
scrollToHash(window.location.hash);
// ========================================================================================================== REUSABLE MARQUEE FUNCTION
function coInitializeTickerCarousel({ 
  selector = '', 
  tickerSpeed = 1, 
  prevNextButtons = true,
  rightScroll = false 
}) {
  let flickity = null;
  let isPaused = false;
  const slideshowEl = document.querySelector(selector);
  if (!slideshowEl) {
    console.error(`Element with selector "${selector}" not found.`);
    return;
  }
  const update = () => {
    if (isPaused) return;
    if (flickity.slides) {
      const direction = rightScroll ? tickerSpeed : -tickerSpeed;
      flickity.x = (flickity.x + direction) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
  };
  const pause = () => {
    isPaused = true;
  };
  const play = () => {
    if (isPaused) {
      isPaused = false;
      window.requestAnimationFrame(update);
    }
  };
  flickity = new Flickity(slideshowEl, {
    autoPlay: false,
    pageDots: false,
    draggable: true,
    prevNextButtons: prevNextButtons,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25
  });
  flickity.x = 0;
  slideshowEl.addEventListener('mouseenter', pause, false);
  slideshowEl.addEventListener('focusin', pause, false);
  slideshowEl.addEventListener('mouseleave', play, false);
  slideshowEl.addEventListener('focusout', play, false);
  flickity.on('dragStart', () => {
    isPaused = true;
  });
  update();
}
// ========================================================================================================== SECTION 2
// ===================================================== GSAP
gsap.set('.co-wholesale-section-2 .co-wholesale-section-marquee-frame', { opacity: 0 });
gsap.to('.co-wholesale-section-2 .co-wholesale-section-marquee-frame', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-2",
    start: "top bottom",
    end: "bottom top"
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
// SCRUB
gsap.set('.co-wholesale-section-2 .co-wholesale-section-marquee-right-image-frame-2 img', { height: "110%", top: "-10%" });
gsap.to('.co-wholesale-section-2 .co-wholesale-section-marquee-right-image-frame-2 img', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-2 .co-wholesale-section-marquee-right",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  top: "0%"
});
// ===================================================== MARQUEE
coInitializeTickerCarousel({ selector: '.co-wholesale-section-2 .co-wholesale-section-marquee-wrapper', tickerSpeed: 1, prevNextButtons: true, rightScroll: false });
// ========================================================================================================== SECTION 3
// ===================================================== GSAP
gsap.set('.co-wholesale-section-3 .co-wholesale-section-marquee-frame', { opacity: 0 });
gsap.to('.co-wholesale-section-3 .co-wholesale-section-marquee-frame', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-3",
    start: "top bottom",
    end: "bottom top"
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
// SCRUB
gsap.set('.co-wholesale-section-3 .co-wholesale-section-marquee-right-image-frame-2 img', { height: "110%", top: "-10%" });
gsap.to('.co-wholesale-section-3 .co-wholesale-section-marquee-right-image-frame-2 img', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-3 .co-wholesale-section-marquee-right",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  top: "0%"
});
// ===================================================== MARQUEE
coInitializeTickerCarousel({ selector: '.co-wholesale-section-3 .co-wholesale-section-marquee-wrapper', tickerSpeed: 1, prevNextButtons: true, rightScroll: true });
// ========================================================================================================== SECTION 4
// ===================================================== GSAP
gsap.set('.co-wholesale-section-4 .co-wholesale-section-marquee-frame', { opacity: 0 });
gsap.to('.co-wholesale-section-4 .co-wholesale-section-marquee-frame', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-4",
    start: "top bottom",
    end: "bottom top"
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
// SCRUB
gsap.set('.co-wholesale-section-4 .co-wholesale-section-marquee-right-image-frame-2 img', { height: "110%", top: "-10%" });
gsap.to('.co-wholesale-section-4 .co-wholesale-section-marquee-right-image-frame-2 img', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-4 .co-wholesale-section-marquee-right",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  top: "0%"
});
// ===================================================== MARQUEE
coInitializeTickerCarousel({ selector: '.co-wholesale-section-4 .co-wholesale-section-marquee-wrapper', tickerSpeed: 1, prevNextButtons: true, rightScroll: false });
// ========================================================================================================== SECTION 5
gsap.set('.co-wholesale-section-5-frame', { opacity: 0 });
gsap.to('.co-wholesale-section-5-frame', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-5-frame",
    start: "top bottom",
    end: "bottom top"
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
// ========================================================================================================== SECTION 6
gsap.set('.co-wholesale-section-6-frame', { opacity: 0 });
gsap.to('.co-wholesale-section-6-frame', {
  scrollTrigger: {
    trigger: ".co-wholesale-section-6-frame",
    start: "top bottom",
    end: "bottom top"
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
// ===================================================== MARQUEE
coInitializeTickerCarousel({ selector: '.co-wholesale-section-6-marquee-wrapper', tickerSpeed: 1, prevNextButtons: true, rightScroll: true });